import React from 'react';
import PropTypes from 'prop-types';

export const ExtraContentPropDefault = {
    onClick: () => {},
    ExtraContent: () => <React.Fragment />,
};

export const CalendarExtraContentContext = React.createContext(ExtraContentPropDefault);

export const withCalendarExtraContentContext = (Child) => (
    (props) => (
        <CalendarExtraContentContext.Consumer>
            {(context) => <Child extraContent={context} {...props} />}
        </CalendarExtraContentContext.Consumer>
    )
);

export const ExtraContentProp = PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    ExtraContent: PropTypes.elementType.isRequired,
});
